/**
 * <SaasPosterPreview />
 *
 * This is a SAAS wrapper for <PosterPreview /> in /shared.
 *
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './SaasPosterPreview.scss';
import FullPanelWrapper from 'components/UI/FullPanelWrapper';
import UtilHeader from 'components/UI/UtilHeader';
import PosterView from 'shared/PosterView'
import getPosterDetail from 'controllers/poster/getPosterDetail';
import Transition from 'components/UI/Transition';
import ShareOnSocialMedia from 'template/Modals/ShareOnSocialMedia';
import Loading from 'components/UI/Loading';
import { browserHistory, Link } from 'react-router';

class SaasPosterPreview extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);

    this.fetchPosterDetail = this.fetchPosterDetail.bind(this);
    this.state = {
      loading: true,
      posterDetail: {},
    }
  }

  componentWillMount() {
    this.fetchPosterDetail();
  }

  fetchPosterDetail() {
    const { posterId } = this.props.params;
    getPosterDetail(posterId)
      .then((posterDetail)=>{
        this.setState({
          loading: false,
          posterDetail,
        }, ()=>{
          this.setPageUrl();
        });
      })
      .catch((err)=>{
        console.error(err);
      });
  }

  setPageUrl() {
    const {
      id,
    } = this.state.posterDetail.poster_info;

    const language = localStorage.getItem('language');

    let pageUrl;

    if (process.env.NODE_ENV === 'development') {
      pageUrl = `https://posterdev.classtop.com/${id}?language=${language}`;
    } else {
      pageUrl = `https://poster.classtop.com/${id}?language=${language}`;
    }

    this.setState({
      pageUrl,
    });
  }

  render() {
    const {
      loading,
      posterDetail,
      scrollTop,
      pageUrl,
    } = this.state;

    const {
      poster_info = {},
    } = posterDetail;
    // <PosterView posterDetail={posterDetail} top={(scrollTop > 88) ? 75 : 0} position={scrollTop > 88 ? 'fixed' : 'relative'} />

    const showShare = poster_info.state === 1;
    const showEdit = poster_info.state !== 1;

    return (
      <div className='saas-poster-preview'>
        <FullPanelWrapper onScroll={(scrollTop)=>{
            this.setState({
              scrollTop,
            });
          }}>
          <Transition>
          { loading === true && <Loading /> }
          { loading !== true &&
            <UtilHeader>
              <div className='preview-buttons'>
                {/* {showEdit && <Link to={`/edit-poster/${poster_info.id}`}><div className='btn btn-primary edit'>{__('Edit', 'poster')}</div></Link>} */}
                { showShare && <div className='btn share' onClick={()=>{
                    ShareOnSocialMedia({ pageTitle: poster_info.title, pageUrl })
                  }}>{__('Share', 'poster')}</div> }
              </div>
            </UtilHeader>
          }
          { loading !== true &&
             <PosterView posterDetail={posterDetail} />
          }
          </Transition>
        </FullPanelWrapper>
      </div>
    )
  }
}

export default SaasPosterPreview;



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/SaasPosterPreview/index.js